import React from "react";
import { Link } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";
import Hero from "../components/Hero";

export default function Services({ t, langData }) {
  const { services, services2, servicesSubtitle } = langData.home2;

  return (
    <>
      <Hero t={t} subtitle={servicesSubtitle} compact />

      <section className="services-section" aria-labelledby="core-services-title">
        <div className="container">
          <div className="services-heading">
            <span className="services-heading__eyebrow">Italiano988 / 01</span>
            <h2 id="core-services-title">{langData.home2.servicesTitle}</h2>
            <p>{servicesSubtitle}</p>
          </div>
          <div className="row g-4">
            {services.map((service, index) => (
              <div className="col-md-6 col-xl-3" key={service.title}>
                <ServiceCard {...service} index={index} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-section services-section--white" aria-labelledby="more-services-title">
        <div className="container">
          <div className="services-heading">
            <span className="services-heading__eyebrow">Italiano988 / 02</span>
            <h2 id="more-services-title">{langData.home2.moreServicesTitle}</h2>
            <p>{langData.home2.moreServicesSubtitle}</p>
          </div>
          <div className="row g-4">
            {services2.map((service, index) => (
              <div className="col-md-6 col-xl-4" key={service.title}>
                <article className="service-detail">
                  <div className="service-detail__top">
                    <span className="service-detail__number">{String(index + 1).padStart(2, "0")}</span>
                    <h3>{service.title}</h3>
                  </div>
                  <ul>{service.text.map((point) => <li key={point}>{point}</li>)}</ul>
                </article>
              </div>
            ))}
          </div>
          <div className="services-cta">
            <div>
              <h3>{langData.home2.ctaTitle}</h3>
              <p>{langData.home2.ctaSubtitle}</p>
            </div>
            <Link to="/contact">{t("contact")} <span aria-hidden="true">↗</span></Link>
          </div>
        </div>
      </section>
    </>
  );
}
